import { useNavigate } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import {
  RunsStatus,
  ScenarioGroupCard,
  ScenarioGroupCardSkeleton,
} from "../../components/Admin/CommandAndControlCards";
import {
  groupRunsByScenario,
  useInjectionRuns,
} from "../../hooks/useInjectionRuns";

// Two rows of placeholders at every breakpoint: 1, 2 or 3 columns -> 2, 4 or 6 cards.
const SKELETON_CARD_VISIBILITY = [
  "flex",
  "flex",
  "hidden lg:flex",
  "hidden lg:flex",
  "hidden 2xl:flex",
  "hidden 2xl:flex",
];

export default function CommandAndControl() {
  const navigate = useNavigate();
  const { runs, isLoading, loadError } = useInjectionRuns();
  const groups = groupRunsByScenario(runs);

  return (
    <AdminLayout>
      <div className="w-full max-w-362.5 mx-auto px-8 py-8 space-y-6 min-h-screen">
        <div>
          <h1 className="text-2xl font-bold text-(--color-text-primary)">
            Command and Control
          </h1>
          <p className="text-xs mt-0.5 text-(--color-text-muted)">
            Live injection-capable scenarios across every organization.
          </p>
        </div>

        <RunsStatus
          isLoading={isLoading}
          loadError={loadError}
          isEmpty={groups.length === 0}
          emptyTitle="No live injection runs"
          emptyText="No team is currently running an injection-capable scenario."
          loadingFallback={
            <div>
              <div className="qv-skeleton h-3 w-28 rounded mb-4" />
              <div className="grid gap-5 lg:grid-cols-2 2xl:grid-cols-3 items-stretch">
                {SKELETON_CARD_VISIBILITY.map((visibility, i) => (
                  <ScenarioGroupCardSkeleton key={i} className={visibility} />
                ))}
              </div>
            </div>
          }
        />

        {!isLoading && !loadError && groups.length > 0 && (
          <div>
            <p className="text-xs text-(--color-text-muted) font-medium mb-4">
              {groups.length} Live{" "}
              {groups.length === 1 ? "Scenario" : "Scenarios"}
            </p>
            <div className="grid gap-5 lg:grid-cols-2 2xl:grid-cols-3 items-stretch">
              {groups.map((group) => (
                <ScenarioGroupCard
                  key={group.scenarioId}
                  group={group}
                  onOpen={() =>
                    navigate(`/admin/command-and-control/${group.scenarioId}`)
                  }
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
